import { useMutation, useQueryClient } from '@tanstack/react-query';

import { duplicateContentService } from '@/services/httpServices/AdminServices';
import type { DuplicateContentServiceConfig } from '@/services/httpServices/AdminServices/types';

import { quizListKeys } from '../queries';
import { courseListKeys } from '../queries/courseQueryKeys';
import { sequenceListKeys } from '../queries/sequenceQueryKeys';

export function useDuplicateContentMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (config: DuplicateContentServiceConfig) => {
      try {
        const response = await duplicateContentService(config);
        return response;
      } catch (error) {
        throw new Error(
          error instanceof Error ? error.message : 'Unknown error',
        );
      }
    },
    onSuccess: async (_, variables) => {
      // Invalidate relevant queries based on content type
      const contentType = variables.params?.body.contentType;

      if (contentType === 'quiz') {
        await queryClient.invalidateQueries({
          queryKey: quizListKeys(),
        });
      } else if (contentType === 'sequence') {
        await queryClient.invalidateQueries({
          queryKey: sequenceListKeys(),
        });
      } else if (contentType === 'course') {
        // Invalidate course lists when courses are duplicated using hierarchical keys
        await queryClient.invalidateQueries({
          queryKey: courseListKeys(),
        });
      }
    },
  });
}
